import React from "react";

import { Badge } from "react-bootstrap";
import Select from "react-select";

import { Button } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";
import { LineInput } from "components/Inputs/LineInput";

import DatasetTile from "components/Tiles/DatasetTile";

import styles from "./style.module.css";

export default class ChooseColumns extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showTable: props.blueprintId ? true : false,
      selectedField: undefined,
      showPriceColumn: props.priceColumn ? true : false,
      showSplitColumn: props.splitColumn ? true : false
    };
  }

  handleUpdateDatasetSelection(dataset) {
    const { updateSelection, updateOutcome } = this.props;

    updateOutcome(undefined);
    return updateSelection(dataset);
  }

  renderTable() {
    const {
      id,
      selectedDataset,
      selectedFields,
      fieldTypes,
      ignored,
      ignoredValue,
      isEditing,
      blueprintId,
      originalDataset,
      options,
      sensitive,
      columnDescription,
      columnDescriptionDataset,
      updateColumnDescription,
      updateColumnDescriptionDataset,
      updateSelectedFields,
      updateFieldTypes,
      updateIgnored,
      updateIsSensitive,
      isDataMode
    } = this.props;
    const { selectedField } = this.state;

    let headers = ["Dataset Field", "Blueprint Field (Match)", "Data Description", "Type"];

    if (blueprintId === "academic") {
      headers = headers.filter((f) => f !== "Blueprint Field (Match)");
    }

    const sOptions = originalDataset
      ? Object.keys(originalDataset.fields)
          .filter(
            (f) =>
              selectedDataset.fields[f] === undefined &&
              selectedFields &&
              Object.keys(selectedFields).filter((s) => selectedFields[s] === f).length === 0
          )
          .map((f) => ({ value: f, label: f }))
      : [];

    const rows = Object.keys(selectedDataset.fields).map((fKey, index) => {
      const field = selectedDataset.fields[fKey];
      const isIgnored = ignored && ignored[field.label] === true;

      const isOutcome = selectedDataset.outcome === field.label;

      const data = [
        "",
        field.label,
        fieldTypes[field.label]
          ? fieldTypes[field.label]
          : field.type && field.type.length > 1
            ? field.type.charAt(0).toUpperCase() + field.type.slice(1)
            : field.type,
        ""
      ];

      let isMatch =
        (originalDataset && originalDataset.fields && originalDataset.fields[fKey] !== undefined) ||
        selectedFields[fKey];

      let match =
        originalDataset && originalDataset.fields[fKey] !== undefined
          ? fKey
          : selectedFields[fKey]
            ? selectedFields[fKey]
            : undefined;

      const isSensitive = sensitive && (sensitive[field.label] === true || (match && sensitive[match] === true));

      Object.keys(selectedFields).forEach((k) => {
        if (selectedFields[k] && selectedFields[k].value && selectedFields[k].value.label) {
          if (selectedFields[k].found === fKey) {
            isMatch = true;
          }
          if (selectedFields[k].found === fKey) {
            match = selectedFields[k].value.value;
          }
        }
      });

      const isLocked = options && options["lock"] === true;

      const cDesc =
        columnDescription && columnDescription[fKey]
          ? columnDescription[fKey]
          : selectedDataset && selectedDataset.descriptions
            ? selectedDataset.descriptions[index]
            : undefined;

      let matchField = undefined;

      originalDataset &&
        originalDataset.fields &&
        match &&
        Object.keys(originalDataset.fields).forEach((f, i) => {
          if (f === match) {
            matchField = originalDataset.fields[f];
          }
        });

      const bDesc = matchField ? matchField.description : undefined;

      return {
        row: (
          <TableRow
            key={index + "_" + (selectedField ? selectedField.label : "")}
            className={
              styles.fieldRow +
              " " +
              (selectedField && selectedField.label === field.label ? styles.selectedFieldRow : "") +
              " " +
              (isMatch && !isIgnored ? styles.matchRow : "")
            }
          >
            <TableColumn>
              <span>{data[1]}</span>
              {isOutcome && <Badge className={styles.outcomeBadge}>{"Outcome"}</Badge>}
              {isMatch && <Badge className={styles.aibleBadge}>{"Match"}</Badge>}
            </TableColumn>
            {blueprintId === "academic" ? (
              ""
            ) : (
              <TableColumn>
                {matchField ? (
                  <div>
                    <span>{matchField.label}</span>
                    <div className={styles.desc}>{matchField.description}</div>
                  </div>
                ) : (
                  <div className={styles.noMatch}>{"No Match Found"}</div>
                )}
              </TableColumn>
            )}
            <TableColumn style={{ width: "50%" }}>
              <LineInput
                isBox
                style={{ height: "50px", justifyContent: "flex-start" }}
                placeholder="Add Description"
                value={cDesc}
                onChange={(value) => updateColumnDescriptionDataset(selectedDataset.id, index, fKey, value)}
              />
            </TableColumn>
            <TableColumn>
              {field.type === "number" && !isLocked && !isDataMode ? (
                <Select
                  options={[
                    { label: "Categorical", value: "Categorical" },
                    { label: "Number", value: "Number" }
                  ]}
                  value={{ label: data[2], value: data[2] }}
                  onChange={(val) => updateFieldTypes(data[1], val.value)}
                />
              ) : (
                data[2]
              )}
            </TableColumn>
          </TableRow>
        ),
        data: data
      };
    });

    return selectedDataset && selectedDataset.fields ? (
      <div className={styles.table} style={{ width: selectedField ? "60%" : "100%" }}>
        <TableLoader headers={headers} rows={rows} minHeight={"240px"} />
      </div>
    ) : (
      <div />
    );
  }

  renderSelectedDataset(selectedDataset) {
    const { blueprintId, isForecast } = this.props;
    const { showTable } = this.state;

    return (
      <div className={styles.dFlex}>
        <div className={styles.dSection}>
          <div className={styles.dMsg}>{"Dataset Selected"}</div>
          {<DatasetTile dataset={selectedDataset} />}
          <div className={blueprintId && blueprintId === "new" ? styles.changeDataset : styles.changeDatasetB}>
            <Button type="secondary" onClick={() => this.handleUpdateDatasetSelection({ value: undefined })}>
              {"Change"}
            </Button>
            {blueprintId === undefined && (
              <div className={styles.toggleHolder}>
                <Button type="secondary" onClick={() => this.setState({ showTable: !showTable })}>
                  {showTable ? "Hide Details" : "Show Details"}
                </Button>
              </div>
            )}
          </div>
          {isForecast && <div className={styles.forecastMsg}>{"This will be treated as a Forecasting run"}</div>}
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      isShow,
      blueprintId,
      selectedDataset,
      ignored,
      updateStep,
      index,
      ignoredValue,
      options,
      isCalculated,
      isContinuous,
      isDataMode
    } = this.props;
    const { selectedField, showTable } = this.state;

    if (selectedDataset === undefined || ignored === undefined) {
      return <div className={styles.emptyMsg}>{"Dataset not selected"}</div>;
    }

    return (
      <div className={styles.body} style={{ opacity: isShow === true ? 1 : 0 }}>
        <AibleStep
          id={id}
          blueprintId={blueprintId}
          bId={"describeColumns"}
          message={"Here you can give descriptions to each column in your data"}
        />
        <div className={styles.tables} style={selectedDataset ? { paddingTop: "20px" } : {}}>
          {showTable && this.renderTable()}
        </div>
      </div>
    );
  }
}
